module.exports = __webpack_public_path__ + "images/rm-team-success-f682999d5cb7e5088d548b54d1f3ad31.jpg";